import React from "react";

type IconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

const PhoneIcon: React.FC<IconProps> = ({ size = 24, fill = "currentColor", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7.21964 3C8.13722 3.00004 8.93737 3.62452 9.16006 4.51465L9.83389 7.20801C10.0043 7.88953 9.80424 8.61067 9.30752 9.10742L6.97355 11.4404C8.30326 13.7634 10.2366 15.6965 12.5595 17.0264L14.8935 14.6934C15.3902 14.1966 16.1114 13.9966 16.7929 14.167L19.4863 14.8408C20.3764 15.0636 21.0009 15.8637 21.0009 16.7812V19C21.0009 20.088 20.1057 21.0395 18.9394 20.9678C10.3957 20.4408 3.56008 13.6052 3.03312 5.06152C2.96131 3.89513 3.9129 3 5.00088 3H7.21964ZM14.4687 17.9453C15.8862 18.5082 17.4095 18.8612 19.0009 18.9658V16.7812L16.3075 16.1074L14.4687 17.9453ZM5.03507 5C5.1397 6.59098 5.492 8.114 6.05459 9.53125L7.89347 7.69336L7.21964 5H5.03507Z"
        fill={fill}
      />
    </svg>
  );
};

export default PhoneIcon;
